import React from 'react'

import { useIntl } from 'react-intl'

import StopPropagation from '@components/UI/StopPropagation/StopPropagation'
import { useModal } from '@context/Modal'
import { EventTrackingNames } from '@enums'
import Theme from '@theme'
import { Icon } from '@tribegroup'
import BrandFanInfluencerIdentityRowTrackedRoute from './../InfluencerIdentity/Row/TrackedRoute'
import BrandFansAudienceInsights from './AudienceInsights'

interface IProps {
  identityId: number
  brandFanMemberId?: number
  brandFanGroupId?: number
}

const BrandFansAudienceInsightsTrigger: React.FC<IProps> = ({
  identityId,
  brandFanGroupId,
  brandFanMemberId,
}) => {
  const { showModal } = useModal()
  const intl = useIntl()
  const onOpenModal = () =>
    showModal(BrandFansAudienceInsights, { identityId, brandFanGroupId, brandFanMemberId })
  return (
    <StopPropagation>
      <BrandFanInfluencerIdentityRowTrackedRoute
        eventName={EventTrackingNames.BrandFansViewInsights}
        identityId={identityId}
      >
        <Icon
          size={0.875}
          glyph="insights"
          data-testid="audience-insights-trigger"
          onClick={onOpenModal}
          color={Theme.primaryColor}
          data-tooltip-id="base-tooltip"
          data-tooltip-content={intl.formatMessage({ id: 'audienceInsights.tooltip' })}
        />
      </BrandFanInfluencerIdentityRowTrackedRoute>
    </StopPropagation>
  )
}

export { BrandFansAudienceInsightsTrigger }
export default BrandFansAudienceInsightsTrigger
